<template>
<v-card >
  <v-card-title >Grow your business</v-card-title>
  <v-card-text >
    <v-list class="ma-3 elevation-4" >
      <v-list-item @click="launchInviteWizard" >
        <v-list-item-content >
          <v-list-item-title >Grow your Team</v-list-item-title>
          <v-list-item-subtitle >
            Add colleagues or reception to your team
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action >
          <v-btn color="primary" icon >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-list class="ma-3 elevation-4" >
      <v-list-item @click="launchNewSpaceWizard" >
        <v-list-item-content >
          <v-list-item-title >Grow your business</v-list-item-title>
          <v-list-item-subtitle >
            Expand your business but adding new businesses or practices (spaces) or locations
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action >
          <v-btn color="primary" icon >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card-text>

</v-card>

</template>

<script>
export default {
  name: 'Grow'
}
</script>